export default "__VITE_ASSET__BBQL90OW__"